import { InputHTMLAttributes, TextareaHTMLAttributes } from 'react'
import './Input.css'

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string
  error?: string
  required?: boolean
}

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string
  error?: string
  required?: boolean
}

export function Input({ label, error, className = '', value, required, ...props }: InputProps) {
  // value가 null인 경우 빈 문자열로 변환 (React warning 방지)
  const safeValue = value === null ? '' : value
  
  return (
    <div className="input-group">
      {label && (
        <label className="input-label">
          {label}
          {required && <span className="input-label--required">*</span>}
        </label>
      )}
      <input
        className={`input ${error ? 'input--error' : ''} ${className}`}
        value={safeValue}
        required={required}
        {...props}
      />
      {error && <span className="input-error">{error}</span>}
    </div>
  )
}

export function Textarea({
  label,
  error,
  className = '',
  value,
  required,
  ...props
}: TextareaProps) {
  // value가 null인 경우 빈 문자열로 변환 (React warning 방지)
  const safeValue = value === null ? '' : value
  
  return (
    <div className="input-group">
      {label && (
        <label className="input-label">
          {label}
          {required && <span className="input-label--required">*</span>}
        </label>
      )}
      <textarea
        className={`input input--textarea ${error ? 'input--error' : ''} ${className}`}
        value={safeValue}
        required={required}
        {...props}
      />
      {error && <span className="input-error">{error}</span>}
    </div>
  )
}

